import { createReducer, on } from '@ngrx/store';

// Actions
import { setPlayAudioState } from './play-audio.actions';

export const playAudioFeatureKey = 'playAudio';

export interface IPlayAudioState {
  state: boolean;
}

export const initialState: IPlayAudioState = {
  state: false,
};

export const playAudioReducer = createReducer(
  initialState,
  on(setPlayAudioState, (currentState, { state }) => ({
    ...currentState,
    state,
  })),
);
